import React from 'react';
import {connect} from 'react-redux';
import Loading from '../common/Loading.jsx';
import * as Action from './redux/actions';


class UserCheckin extends React.Component {
  constructor() {
    super();

    this.state = {
        expandedRows: [],
        expandedUserRows: [],
        filterText: '',
    };
  }

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(Action.getUserCheckins({expand: 'location_type,user,membership'}));
  }

  isRowExpanded = (userId) => {
    const checkins = this.props.groupByUser[userId];
    if (this.state.expandedRows.includes(checkins[0].id)) {
      return true;
    }
    return false;
  };

  closeUserCheckins = (userId) => {
    const currentExpandedRows = this.state.expandedRows;
    const currentExpandedUserRows = this.state.expandedUserRows;
    const checkins = this.props.groupByUser[userId];
    for (let i = 0; i < checkins.length; i++) {
      currentExpandedRows.splice(currentExpandedRows.indexOf(checkins[i].id), 1);
    }
    currentExpandedUserRows.splice(currentExpandedUserRows.indexOf(userId), 1);
    this.setState({expandedRows: currentExpandedRows, expandedUserRows: currentExpandedUserRows});
  };

  openUserCheckins = (userId) => {
    const currentExpandedRows = this.state.expandedRows;
    const currentExpandedUserRows = this.state.expandedUserRows;
    const checkins = this.props.groupByUser[userId];
    for (let i = 0; i < checkins.length; i++) {
      currentExpandedRows.push(checkins[i].id);
    }
    currentExpandedUserRows.push(userId);
    this.setState({expandedRows: currentExpandedRows, expandedUserRows: currentExpandedUserRows});
  };

  handleRowClick(userId) {
    if (this.isRowExpanded(userId)) {
      this.closeUserCheckins(userId);
    } else {
      this.openUserCheckins(userId);
    }
  }

  filterCheckin = () => {
    const {dispatch} = this.props;
    dispatch(Action.getUserCheckins({expand: 'location_type,user,membership', q: this.state.filterText}));
  };

  renderItem(items) {
      const firstRow = items[0];
      const clickCallback = () => this.handleRowClick(firstRow.user.id);
      const icon = this.state.expandedUserRows.includes(firstRow.user.id) ? 'fa fa-chevron-up' : 'fa fa-chevron-down';
      const itemRows = [
        <tr onClick={clickCallback} key={'row-data-' + firstRow.user.id}>
          <th scope="col"><input type="text" disabled style={{maxWidth: '10px', maxHeight: '10px'}}/></th>
          <td>{firstRow.user.firstName} {firstRow.user.lastName}</td>
          <td>{firstRow.user.email}</td>
          <td>{firstRow.user.membership ? firstRow.user.membership.membershipId : ''}</td>
          <td>{firstRow.provider}</td>
          <td>{items.length}</td>
          <td><i className={icon} /></td>
        </tr>
      ];

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (this.state.expandedRows.includes(item.id)) {
            const date = new Date(item.checkinDate);
            // use options to show timezone when backend gives us timezone
            // const options = {timeZone: 'UTC', timeZoneName: 'short'};
            // {date.toLocaleString('en-US', options)}
            itemRows.push(
              <tr key={'row-expanded-' + item.id} className="no-border">
                <td />
                <td>{date.toLocaleString('en-US')}</td>
                <td colSpan="4" style={{textAlign: 'left'}}>{item.locationName} {item.locationType.title}</td>
                <td />
              </tr>
            );
        }
      }

      return itemRows;
  }


  render() {
    const {isFetching, groupByUser} = this.props;
    let allItemRows = [];
    const itemKeys = Object.keys(groupByUser);
    itemKeys.forEach((index) => {
        const perItemRows = this.renderItem(groupByUser[index]);
        allItemRows = allItemRows.concat(perItemRows);
    });
    if (!itemKeys.length) {
      allItemRows = [
        <tr className="no-border">
          <td colSpan="4">No records found</td>
        </tr>
      ];
    }

    return (
      <div className="ba-home">
        <div className="row ba-panel">
          {isFetching ? <Loading/> : null}
          <div className="row">
            <div className="small-6 columns" style={{paddingLeft: '30px', paddingTop: '20px'}}>
              <div className="small-6 columns search">
                <i className="fa fa-search" onClick={this.filterCheckin} />
                <input type="text"
                    onChange={(e) => { this.setState({filterText: e.target.value}); }}
                    style={{float: 'left'}}
                    placeholder="Search by location"
                    value={this.state.filterText}
                    onKeyUp={(e) => {
                        if (e.keyCode == 13) {
                          this.filterCheckin();
                        }
                    }}
                />
              </div>

            </div>
          </div>
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col" style={{width: '5%'}}>
                  <input type="text" disabled style={{maxWidth: '10px', maxHeight: '10px'}}/>
                </th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Membership ID</th>
                <th scope="col">Payer</th>
                <th scope="col" style={{width: '10%'}} >Check-In's</th>
                <th scope="col" style={{width: '5%'}} />
              </tr>
            </thead>
            <tbody>
              {allItemRows}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

UserCheckin.displayName = 'UserCheckin';

function mapStateToProps(state) {
  return {...state.checkin};
}

export default connect(mapStateToProps)(UserCheckin);



// WEBPACK FOOTER //
// ./shared/checkins/UserCheckin.jsx